import { BugAntIcon } from "@heroicons/react/20/solid";

const BugReport = () => {
  return (
    <a
      href="https://airtable.com/appQVek7Zz7RYjNIh/shr8DRqit84dHnpRn"
      target="_blank"
    >
      <span className="inline-flex items-center rounded-md bg-gray-50 text-xs font-medium text-gray-800 ring-1 ring-inset ring-gray-600/20 p-2">
        <BugAntIcon className="h-4 h-5 text-gray-600 mr-2" />
        Bug Report
      </span>
    </a>
  );
};

export default BugReport;
